/**
 * 1. 列表显示   find + 业务名
 * 2. 搜索查询   search + 业务名（如果和列表显示用同一个接口，可以不需要这个）
 * 3. 添加操作   create + 业务名
 * 4. 修改操作   update + 业务名
 * 5. 删除操作   remove + 业务名
 */

export default {}